var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxOutlineDocumentText3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.82,
    height: 22.74,
    viewBox: "0 0 21.82 22.74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    id: "Capa_2",
    "data-name": "Capa 2",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,17.56a5.18,5.18,0,0,1,5-5.31,5.18,5.18,0,0,1,5,5.31,5.19,5.19,0,0,1-5,5.32A5.19,5.19,0,0,1,12,17.56Zm.78,0A4.39,4.39,0,0,0,17,22.06a4.39,4.39,0,0,0,4.27-4.5A4.38,4.38,0,0,0,17,13.07,4.38,4.38,0,0,0,12.78,17.56ZM21.66,24c-.24,0-.68-.21-.93-1a1.3,1.3,0,0,1,.13-1.13,1.15,1.15,0,0,1,1-.48A1.17,1.17,0,0,1,23,22a1.32,1.32,0,0,1-.16,1.32,1.22,1.22,0,0,1-1,.7Zm.1-.81c.09,0,.24-.09.4-.34a.59.59,0,0,0,.13-.48c0-.07-.18-.15-.45-.15a.42.42,0,0,0-.35.14.47.47,0,0,0,0,.39C21.56,23,21.68,23.16,21.76,23.17Z",
    transform: "translate(-1.25 -1.25)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,21.25H9c-4.61,0-6.25-1.64-6.25-6.25V9C2.75,4.39,4.39,2.75,9,2.75h4.25V6c0,3.42,1.33,4.75,4.75,4.75h3.25v2.07a6.56,6.56,0,0,1,1.5,2.28V10a1,1,0,0,0,0-.17.35.35,0,0,0,0-.11.48.48,0,0,0-.09-.14.41.41,0,0,0-.07-.11l-8-8a.7.7,0,0,0-.21-.14l-.09,0-.17,0H9C3.57,1.25,1.25,3.57,1.25,9v6c0,5.43,2.32,7.75,7.75,7.75h4.34A6.13,6.13,0,0,1,12,21.25ZM14.75,3.81l5.44,5.44H18c-2.58,0-3.25-.67-3.25-3.25Z",
    transform: "translate(-1.25 -1.25)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11,16.25H7a.75.75,0,0,0,0,1.5h3.88c0-.06,0-.12,0-.19A7,7,0,0,1,11,16.25Z",
    transform: "translate(-1.25 -1.25)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.36,12.36a.76.76,0,0,0-.36-.11H7a.75.75,0,0,0,0,1.5h5.06A6.14,6.14,0,0,1,13.36,12.36Z",
    transform: "translate(-1.25 -1.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineDocumentText3);
export default __webpack_public_path__ + "static/media/vuesax-outline-document-text-3.b1c59c3f2f0dd28a2ccd001039efccae.svg";
export { ForwardRef as ReactComponent };